var _rect, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSherwebLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 64,
    viewBox: "0 0 180 64",
    role: "img",
    "aria-label": "Sherweb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 64,
    rx: 8,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15h28c7.2 0 13 5.8 13 13s-5.8 13-13 13H37v8h-9V15zm9 8v10h18.6c2.8 0 5-2.2 5-5s-2.2-5-5-5H37z",
    fill: "#0068B5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 40,
    fill: "#1F2937",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Sherweb")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSherwebLogo);
export default __webpack_public_path__ + "static/media/sherweb_logo.aff001c8b866c874687016aa98a66c08.svg";
export { ForwardRef as ReactComponent };